<template>
  <g>
    <path
      d="M9 12.0002C11.2091 12.0002 13 10.2094 13 8.00024C13 5.79111 11.2091 4.00024 9 4.00024C6.79086 4.00024 5 5.79111 5 8.00024C5 10.2094 6.79086 12.0002 9 12.0002Z"
    />
    <path
      d="M9 14.0002C6.33 14.0002 1 15.3402 1 18.0002V19.0002C1 19.5502 1.45 20.0002 2 20.0002H16C16.55 20.0002 17 19.5502 17 19.0002V18.0002C17 15.3402 11.67 14.0002 9 14.0002Z"
    />
    <path
      d="M20 10.0002V7.00024H18V10.0002H15V12.0002H18V15.0002H20V12.0002H23V10.0002H20Z"
    />
  </g>
</template>
